import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
  UserName: Yup.string()
    .required('Email or Registration Number is required')
    .test(
      'email-or-username',
      'Enter a valid Email or Registration Number',
      (value) => {
        if (!value) return false;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // only treat as email if it has @ and a dot after it (real email pattern)
        const looksLikeEmail =
          value.includes('@') &&
          value.substring(value.indexOf('@')).includes('.');

        if (looksLikeEmail) {
          return emailRegex.test(value);
        }

        // allow usernames like abc@, student@12, REG123
        return true;
      }
    ),

  Password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .max(50, 'Password must be at most 50 characters')
    .required('Password is required'),
});
